

import __layout_0 from '/opt/atlassian/pipelines/agent/build/src/layouts/default.vue'
export const layouts = {
'auth': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/auth.vue'),
'default': __layout_0,
'preview': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/preview.vue'),
'verification': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/verification.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
